import { c as _c } from "react/compiler-runtime";
import { ResponsiveImage } from '@/app/components/media/app-image';
import { Link } from '@/app/components/navigation/link';
import { getSpartanRevealItemProps, SPARTAN_REVEAL_ROLE } from '@/app/lcv/components/sections/spartan/products/shared/reveal';
import type { SpartanCarouselImageLoading } from '@/app/lcv/components/sections/spartan/shared/hooks/useCarouselImageLoading';
import { getSpartanLineupModelCardResponsiveSources, SPARTAN_LINEUP_MODEL_CARD_IMAGE_SIZE } from '@/app/lcv/components/sections/spartan/shared/lineup/carousel/model-card/image-media';
import { SPARTAN_LINEUP_LABELS } from '@/app/lcv/components/sections/spartan/shared/lineup/constants';
import styles from '@/app/lcv/components/sections/spartan/shared/lineup/styles.module.css';
import { SPARTAN_LINEUP_DATA_GA, SPARTAN_LINEUP_TRACKING } from '@/app/lcv/components/sections/spartan/shared/lineup/tracking';
import type { SpartanLineupModel } from '@/app/lcv/components/sections/spartan/shared/lineup/types';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
export const SpartanLineupModelCardImageLink = t0 => {
  const $ = _c(25);
  const {
    model,
    modelIndex,
    eventName,
    imageLoading,
    showLightModelImageBackground,
    isDark: t1,
    isVehicleRevealEnabled: t2,
    onPrefetchDetail
  } = t0;
  const isDark = t1 === undefined ? false : t1;
  const isVehicleRevealEnabled = t2 === undefined ? true : t2;
  const t3 = model.href;
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = cn("relative block size-full overflow-hidden rounded-t-lg", styles.modelCardImageMedia);
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  let t5;
  if ($[1] !== modelIndex) {
    t5 = createDataAttributes({
      test: SPARTAN_LINEUP_TRACKING.modelImageLink(modelIndex)
    });
    $[1] = modelIndex;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== eventName || $[4] !== model.href) {
    t6 = createDataGA({
      eventName,
      group: SPARTAN_LINEUP_DATA_GA.section,
      click: true,
      text: SPARTAN_LINEUP_LABELS.detail,
      url: model.href
    });
    $[3] = eventName;
    $[4] = model.href;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== imageLoading || $[7] !== isDark || $[8] !== model.imageBackground || $[9] !== modelIndex || $[10] !== showLightModelImageBackground) {
    t7 = showLightModelImageBackground ? <><ResponsiveImage {...getSpartanLineupModelCardResponsiveSources(model.imageBackground.src)} alt="" {...SPARTAN_LINEUP_MODEL_CARD_IMAGE_SIZE} objectFit="cover" aria-hidden={true} className="absolute inset-0 size-full" imgClassName="rounded-t-lg" testId={SPARTAN_LINEUP_TRACKING.modelImageBackground(modelIndex)} {...imageLoading} /><div aria-hidden={true} className={cn(isDark ? styles.darkFilledModelImageBackgroundGradient : styles.lightModelImageBackgroundGradient, "rounded-t-lg")} /></> : null;
    $[6] = imageLoading;
    $[7] = isDark;
    $[8] = model.imageBackground;
    $[9] = modelIndex;
    $[10] = showLightModelImageBackground;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== imageLoading || $[13] !== isVehicleRevealEnabled || $[14] !== model.image || $[15] !== model.title || $[16] !== modelIndex) {
    t8 = model.image?.src ? <div className="relative z-10 size-full" {...isVehicleRevealEnabled ? getSpartanRevealItemProps({
      order: Math.min(modelIndex, 3),
      role: SPARTAN_REVEAL_ROLE.lineupImage,
      staggerMs: 60
    }) : {}}><ResponsiveImage {...getSpartanLineupModelCardResponsiveSources(model.image.src)} alt={model.title} {...SPARTAN_LINEUP_MODEL_CARD_IMAGE_SIZE} objectFit="cover" className="size-full" imgClassName="rounded-t-lg" testId={SPARTAN_LINEUP_TRACKING.modelImage(modelIndex)} {...imageLoading} /></div> : null;
    $[12] = imageLoading;
    $[13] = isVehicleRevealEnabled;
    $[14] = model.image;
    $[15] = model.title;
    $[16] = modelIndex;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== model.href || $[19] !== onPrefetchDetail || $[20] !== t5 || $[21] !== t6 || $[22] !== t7 || $[23] !== t8) {
    t9 = <Link href={t3} prefetch={false} className={t4} onMouseEnter={onPrefetchDetail} onFocus={onPrefetchDetail} onTouchStart={onPrefetchDetail} {...t5} {...t6}>{t7}{t8}</Link>;
    $[18] = model.href;
    $[19] = onPrefetchDetail;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};